module.exports = __webpack_public_path__ + "static/media/section-home-persons-vector-bg.8b322d51.png";